import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useValidationSchemaReferralManager = () => {
  const { t } = useTranslation();
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      employeeId: Yup.string().required(t('errors.requiredField')),
      employeeFullName: Yup.string(),
    });
  }, [t]);

  return { validationSchema };
};
